/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from '@mummssoftware/common-ui';
import {
  ExpansionHeaderDiv,
  ExpansionDiv,
  TitleHeaderDiv,
} from '../../components';
import { SingularPsoUI } from './SingularPsoUI';

type StandingOrdersProps = {
  patientStandingOrdersGlobal: mumms.PatientStandingOrderDTOv2[] | null;
  patientOrdersGlobal: mumms.Order[] | null;
  patient?: mumms.patient;
};

export const StandingOrders = ({
  patient,
  patientStandingOrdersGlobal,
  patientOrdersGlobal,
}: StandingOrdersProps) => {
  const firstPanelId = patientStandingOrdersGlobal
    ? patientStandingOrdersGlobal[0].id
    : '';
  const [expanded, setExpanded] = useState<string>(firstPanelId);
  const style = {
    position: 'sticky',
    top: '0',
    zIndex: '2',
  };

  const handleChange = (panel: string) => (event: any) => {
    if (panel === expanded) {
      setExpanded('');
    } else {
      setExpanded(panel);
    }
  };

  return (
    <ExpansionDiv id="expanded-pso">
      {patientStandingOrdersGlobal &&
        patientStandingOrdersGlobal.map((pso: any, i: number) => (
          <ExpansionPanel
            expanded={expanded === pso.id}
            onChange={handleChange(pso.id)}
            key={`cpp-${pso.id}`}
          >
            <ExpansionPanelSummary style={expanded ? style : null}>
              <ExpansionHeaderDiv id={pso.id} index={i}>
                <TitleHeaderDiv
                  id={pso.id}
                >{`${pso.standingordername} at ${pso.createdate}`}</TitleHeaderDiv>
              </ExpansionHeaderDiv>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <SingularPsoUI
                patient={patient}
                pso={pso}
                patientOrdersGlobal={patientOrdersGlobal}
              />
            </ExpansionPanelDetails>
          </ExpansionPanel>
        ))}
    </ExpansionDiv>
  );
};

export default StandingOrders;
